var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDine2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_126_1854",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 54,
    height: 54
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_126_1854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.6247 48.375V45H50.6247V48.375H23.6247ZM25.8747 42.3174C25.8747 39.4963 26.784 37.0413 28.6028 34.9526C30.4215 32.8642 32.6997 31.6224 35.4372 31.2271V30.0594C35.4372 29.5948 35.5988 29.1973 35.922 28.8669C36.2449 28.5369 36.6458 28.3719 37.1247 28.3719C37.5889 28.3719 37.9862 28.5369 38.3166 28.8669C38.647 29.1973 38.8122 29.5948 38.8122 30.0594V31.2271C41.5264 31.6224 43.7987 32.8642 45.6291 34.9526C47.4595 37.0413 48.3747 39.4963 48.3747 42.3174H25.8747ZM30.18 38.9075H43.9787C43.396 37.5778 42.4937 36.4918 41.272 35.6495C40.0502 34.8073 38.6678 34.3861 37.1247 34.3861C35.5583 34.3861 34.1548 34.8073 32.9143 35.6495C31.6742 36.4918 30.7628 37.5778 30.18 38.9075ZM3.41797 28.0383V6.49065H14.668V9.5799L31.1104 4.88977L47.9848 10.1683V11.8125C47.9848 13.3991 47.3972 14.7549 46.222 15.8799C45.0463 17.0049 43.6292 17.5674 41.9706 17.5674H36.8648V18.7875C36.8648 19.6383 36.5967 20.4157 36.0604 21.1196C35.5238 21.8235 34.8602 22.3297 34.0697 22.6383L19.5313 28.0383H3.41797ZM6.79297 24.6633H11.293V9.86565H6.79297V24.6633ZM14.668 24.6633H18.9604L32.2264 19.7955C32.61 19.6601 32.9166 19.4287 33.1461 19.1013C33.3752 18.774 33.4898 18.3997 33.4898 17.9786V17.5674H29.3233L22.7421 19.7263L21.6947 16.5116L28.7046 14.1924H41.9706C42.3947 14.1924 42.8959 14.0525 43.4742 13.7728C44.0528 13.493 44.371 13.1049 44.4287 12.6084L30.9979 8.4459L14.668 13.0674V24.6633Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDine2);
export default __webpack_public_path__ + "static/media/dine2.f3e0600fc03ac0911dc2ae3f5ba7dcfe.svg";
export { ForwardRef as ReactComponent };